import { render, staticRenderFns } from "./setMealList.vue?vue&type=template&id=404e8689&"
import script from "./setMealList.vue?vue&type=script&lang=js&"
export * from "./setMealList.vue?vue&type=script&lang=js&"
import style0 from "./setMealList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports